"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ctaTexts = void 0;
exports.ctaTexts = {
    'call': 'Call',
    'email': 'Email',
    'app': 'Get App',
    'donate': 'Donate',
    'learn-more': 'Learn More',
    'register': 'Register',
    'signup': 'Sign Up',
    'rsvp': 'RSVP',
    'order': 'Order',
    'join-meeting': 'Join Meeting',
    'subscribe': 'Subscribe',
    'survey': 'Survey',
    'download': 'Download'
};
//# sourceMappingURL=FlyerEmail.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/flyer-email-builder/dist/api/FlyerEmail.js
// module id = 3332
// module chunks = 0